import React, { useState } from "react";
import PasswordPage from "./components/PasswordPage";
import Navbar from './components/Navbar';
import Welcome from './pages/Welcome';
import OurStory from './pages/OurStory';
import Venue from './pages/Venue';
import WeddingParty from './pages/WeddingParty';
import Events from './pages/Events';
import Information from './pages/Information';
import Activities from './pages/Activities';
import RSVP from './pages/RSVP';
import Registry from './pages/Registry';

const App = () => {
    const [accessGranted, setAccessGranted] = useState(false);

    const handleAccessGranted = () => {
        setAccessGranted(true);
    };

    return (
        <div>
            {accessGranted ? (
                <>
                    <Navbar />
                    <div id="welcome" className="section1"><Welcome /></div>
                    <div id="venue" className="section3"><Venue /></div>
                    <div id="events" className="section"><Events /></div>
                    <div id="our-story" className="section2"><OurStory /></div>
                    <div id="information" className="section"><Information /></div>
                    <div id="activities" className="section"><Activities /></div>
                    <div id="wedding-party" className="section"><WeddingParty /></div>
                    <div id="rsvp" className="section"><RSVP /></div>
                    <div id="registry" className="section"><Registry /></div>
                </>
            ) : (
                <PasswordPage onAccessGranted={handleAccessGranted} />
            )}
        </div>
    );
};

export default App;
